import { combineReducers } from 'redux';
import {
  SET_BID_STAGING_EQUIPMENT,
  SET_BID_STAGING_DEVICES,
  SET_BID_STAGING_POINTS,
  SET_PAGE,
  MARK_STAGING_LOADING,
  SET_VALIDATION,
  DELETE_STAGING_EQUIPMENT,
  UPDATE_STAGING_EQUIP,
  UPDATE_STAGING_POINTS,
  REMOVE_MULTIPLE_EQUIPMENT,
} from '../actions/actiontypes';
import { groupByProperty } from '../../utils/collections';

const page = (state = 0, action) => {
  if (action.type === SET_PAGE) {
    return action.newPage;
  }

  return state;
};

const loaded = (state = {}, action) => {
  if (action.type === SET_BID_STAGING_EQUIPMENT) {
    return { ...state, [action.buildingId]: true };
  }
  if (action.type === MARK_STAGING_LOADING) {
    return { ...state, [action.buildingId]: false };
  }
  return state;
};

const devicesLoaded = (state = {}, action) => {
  if (action.type === SET_BID_STAGING_DEVICES) {
    return { ...state, [action.buildingId]: true };
  }
  if (action.type === MARK_STAGING_LOADING) {
    return { ...state, [action.buildingId]: false };
  }
  return state;
};

const pointsLoaded = (state = {}, action) => {
  if (action.type === SET_BID_STAGING_POINTS) {
    return { ...state, [action.buildingId]: true };
  }
  if (action.type === MARK_STAGING_LOADING) {
    return { ...state, [action.buildingId]: false };
  }
  return state;
};

const equipmentLoaded = (state = {}, action) => {
  if (action.type === SET_BID_STAGING_EQUIPMENT || action.type === UPDATE_STAGING_EQUIP) {
    return { ...state, [action.buildingId]: true };
  }
  if (action.type === MARK_STAGING_LOADING) {
    return { ...state, [action.buildingId]: false };
  }
  return state;
};

const equipmentByBuilding = (state = {}, action) => {
  if (action.type === SET_BID_STAGING_EQUIPMENT) {
    return { ...state, [action.buildingId]: action.equipment };
  }
  if (action.type === UPDATE_STAGING_EQUIP) {
    const newState = { ...state };
    if (!newState[action.buildingId]) {
      newState[action.buildingId] = action.equipment;
    } else {
      const updates = action.equipment.reduce((o, e) => {
        // eslint-disable-next-line no-param-reassign
        o[e.equip_id] = e;
        return o;
      }, {});
      newState[action.buildingId] = newState[action.buildingId].map((e) => {
        const update = updates[e.equip_id];
        if (update != null) {
          delete updates[e.equip_id];
          return update;
        }
        return e;
      });
      newState[action.buildingId] = newState[action.buildingId].concat(Object.values(updates));
    }
    return newState;
  }
  if (action.type === DELETE_STAGING_EQUIPMENT) {
    const newState = { ...state };
    newState[action.buildingId] = newState[action.buildingId].filter(
      (e) => !action.equipIds.includes(e.equip_id)
    );
    return newState;
  }
  if (action.type === REMOVE_MULTIPLE_EQUIPMENT) {
    // unpublish
    const newState = { ...state };
    newState[action.buildingId] = newState[action.buildingId].map((e) => {
      if (action.equipmentIds.includes(e.promoted_equipment_id)) {
        const { promoted_equipment_id: _, ...newEquip } = { ...e };
        return newEquip;
      }
      return e;
    });
    return newState;
  }
  return state;
};

const pointsByBuilding = (state = {}, action) => {
  if (action.type === SET_BID_STAGING_POINTS) {
    return { ...state, [action.buildingId]: groupByProperty('topic', action.points) };
  }
  if (action.type === UPDATE_STAGING_POINTS) {
    const newState = { ...state };
    const updatesByTopic = groupByProperty('topic', action.points);
    if (!newState[action.buildingId]) {
      newState[action.buildingId] = action.updatesByTopic;
    } else {
      newState[action.buildingId] = { ...newState[action.buildingId], ...updatesByTopic };
    }
    return newState;
  }
  return state;
};

const devicesByBuilding = (state = {}, action) => {
  if (action.type === SET_BID_STAGING_DEVICES) {
    return { ...state, [action.buildingId]: action.devices };
  }
  return state;
};

// validation reducers

const points = (state = {}, action) => {
  if (action.type === SET_VALIDATION) {
    return { ...state, [action.buildingId]: action.points };
  }
  if (action.type === SET_BID_STAGING_EQUIPMENT && !(action.buildingId in state)) {
    return { ...state, [action.buildingId]: {} };
  }
  return state;
};

const equipment = (state = {}, action) => {
  if (action.type === SET_VALIDATION) {
    return { ...state, [action.buildingId]: action.equipment };
  }
  if (action.type === SET_BID_STAGING_EQUIPMENT && !(action.buildingId in state)) {
    return { ...state, [action.buildingId]: {} };
  }
  return state;
};

export default combineReducers({
  loaded,
  devicesLoaded,
  pointsLoaded,
  equipmentLoaded,
  page,
  equipmentByBuilding,
  pointsByBuilding,
  devicesByBuilding,
  validation: combineReducers({ points, equipment }),
});
